import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TagList } from '../components/tags/tag-list';
import { TagQueryFilter } from '../components/tags/tag-query-filter';
import { CreateTag, UpdateTag } from '../components/tags/tags';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TagsService {
  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getTagQueryParams(filter: TagQueryFilter): HttpParams {
    return new HttpParams({ fromObject: filter })
  }

  getAllTags(queryFilter:TagQueryFilter): Observable<any> {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let param = this.getTagQueryParams(queryFilter)
      return this.http.get<TagList[]>(this.apiUrl + "tags/getAllTags",{headers:headers,params:param,observe:'response'});
  }

  getActiveTags():Observable<any>
  {
    return this.http.get<any[]>(this.apiUrl + "tags/getActiveTags");
  }

  getAllCategories():Observable<any>{
    return this.http.get<any[]>(this.apiUrl + "tags/getCategories");
  }

  createTag(tag:CreateTag):Observable<any>{
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl+"tags/createTag",tag,{headers:headers});
  }

  updatetag(tag:UpdateTag):Observable<any>{
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl+'tags/updateTag',tag,{headers:headers});
  }

  getTagDetailsById(tagid:string):Observable<any>{
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id',tagid.toString());
    return this.http.get<any>(this.apiUrl+"tags/getTagDetailsById",{headers:headers,params:params});
  }

  getTagAuditLogs(tagid:string):Observable<any>{
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id',tagid.toString());
    return this.http.get<any>(this.apiUrl+"tags/getTagAuditLogs",{headers, params});
  }

 
}
